
export {orient2d, orient2dfast} from './esm/orient2d.js';
export {orient3d, orient3dfast} from './esm/orient3d.js';
export {incircle, incirclefast} from './esm/incircle.js';
export {insphere, inspherefast} from './esm/insphere.js';



//////////////////
// WEBPACK FOOTER
// ./node_modules/robust-predicates/index.js
// module id = 4622
// module chunks = 0